import { Helmet } from "react-helmet";
import wrapperHOC from "@Utils/wrapperHOC";
import V2Footer from "@Components/V2Footer/V2Footer";
// Navbar is a shared component; the document furniture — hero, body renderer
// and closing seal — is shared with /privacy-v2.
import Navbar from "@Components/Navbar/Navbar";
import LegalHero from "@Components/LegalDoc/LegalHero";
import LegalDoc from "@Components/LegalDoc/LegalDoc";
import LegalSeal from "@Components/LegalDoc/LegalSeal";
import TERMS_CONTENT from "./content/terms";
import styles from "./TermsV2.module.scss";
import { CONTACT_URL, PRIVACY_URL } from "constants/configConstants";
import useTranslationHook from "hooks/useTranslationHook";
import useIsApp from "hooks/useIsApp";

const TermsV2 = () => {
  const { t } = useTranslationHook();
  const isApp = useIsApp();

  return (
    <div className={styles.page}>
      {/* The live page's own meta keys — same document, same description. */}
      <Helmet title={t("terms.meta.title")}>
        <meta name="description" content={t("terms.meta.description")} />
        {/* Instrument Sans — the design font, loaded only on this page */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Instrument+Sans:wght@400;500;600;700&display=swap"
        />
      </Helmet>

      <Navbar
        isAppHeader={isApp}
        links={[
          { label: "terms.v2.navbar.privacy", href: PRIVACY_URL },
          { label: "navbar.v2.support", href: CONTACT_URL },
        ]}
      />
      <LegalHero title={t("terms.page.title")} subtitle={t("terms.v2.hero.subtitle")} />
      <LegalDoc content={TERMS_CONTENT} />
      <LegalSeal />
      <V2Footer />
    </div>
  );
};

export default wrapperHOC(TermsV2, {
  componentName: "TermsV2-Page",
  showForChina: true,
});
